"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const getCurrent = (options, selected) => {
    if (!selected.length)
        return options;
    const [currentIdx, ...rest] = selected;
    const currentOption = options[currentIdx].options;
    return getCurrent(currentOption, rest);
};
const handleBackAction = (state) => {
    if (state.selected.length < 1)
        return state;
    const selected = state.selected.slice(0, state.selected.length - 1);
    return {
        ...state,
        selected,
        current: getCurrent(state.menu, selected)
    };
};
var Actions;
(function (Actions) {
    Actions[Actions["BACK"] = 0] = "BACK";
    Actions[Actions["SELECT"] = 1] = "SELECT";
})(Actions || (Actions = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case Actions.SELECT:
            return {
                ...state,
                selected: [...state.selected, action.payload],
                current: getCurrent(state.menu, [...state.selected, action.payload])
            };
        case Actions.BACK:
            return handleBackAction(state);
        default:
            return state;
    }
};
const renderOption = (dispatch, onClick) => (option, idx) => {
    if ("title" in option) {
        return ((0, jsx_runtime_1.jsxs)(ListItem, { onClick: ((_e) => {
                onClick && onClick(true);
                dispatch && dispatch({ type: Actions.SELECT, payload: idx });
            }), children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: option.title }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: ["fal", "chevron-right"] }, void 0)] }, option.title));
    }
    return ((0, jsx_runtime_1.jsx)(ListItem, { onClick: () => {
            onClick && onClick(false);
        }, children: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: option }, void 0) }, "option" + idx));
};
const Menu = ({ options, onChangeMenuLevel, level = 0, onOptionClick }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer, {
        selected: [],
        current: options,
        menu: options
    });
    (0, react_1.useEffect)(() => {
        onChangeMenuLevel && onChangeMenuLevel(state.selected.length);
    }, [state.selected.length]);
    (0, react_1.useEffect)(() => {
        if (state.selected.length - level === 1)
            dispatch({ type: Actions.BACK });
    }, [level]);
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: state.current.map(renderOption(dispatch, onOptionClick)) }, void 0));
};
exports.Menu = Menu;
const Wrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `0  ${theme.spacings.m}`};
`;
const ListItem = styled_components_1.default.li `
  align-items: center;
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.silverLighten70};
  display: flex;
  justify-content: space-between;

  & > h4 {
    cursor: pointer;
    flex: 1;
    font-weight: 400;
    padding: ${({ theme }) => `${theme.spacings.m} 0 ${theme.spacings.xs}`};
  }

  & > div {
    cursor: pointer;
  }

  & a {
    display: inline-block;
    height: 100%;
    text-decoration: none;
    width: 100%;
  }
`;
//# sourceMappingURL=Menu.js.map